<template>
    <div>
        <OptionsPanel
            ref="optionspanel"
            :tabs="tabs" 
            :saving="saving" 
            :initial-tab="initialTab"
            :initial-data="initialData"
            :more-label-index="7"
            @settings-change="settingsChangeHandler" />
    </div>
</template>

<script>
import eventBus from '@/utils/event-bus';
import { setPermanentData } from '@/utils/browser-storage';
import { mapGetters } from 'vuex';
import { updateQueryParams } from '@/utils/url-utils'

export default {
    components: {
        OptionsPanel: () => import(/* webpackChunkName: "OptionsPanel" */ '@/components/OptionsPanel.vue'),
    },
    data() {
        return {
            saving: false, 
            data: {},
            popupInitialized: false,
            initialData: {},
            tabs: [
                {
                    label: 'Allgemein',
                    id: 'general',
                    component: 'RouteSettingsGeneral',
                },
                {
                    label: 'Auto',
                    id: 'car',
                    component: 'RouteSettingsCar',
                },
                {
                    label: 'Öffis',
                    id: 'public',
                    component: 'RouteSettingsPublic'
                },
                // {
                //     label: 'Fußgänger',
                //     id: 'fussgaenger'
                // },
                {
                    label: 'Fahrrad',
                    id: 'bike',
                     component: 'RouteSettingsBike',
                },
                {
                    label: 'Motorrad',
                    id: 'motorcycle',
                    component: 'RouteSettingsMotorcycle',
                },
                {
                    label: 'Wohnmobil',
                    id: 'camper',
                    component: 'RouteSettingsCamper',
                },
                {
                    label: 'Gespann',
                    id: 'trailer',
                    component: 'RouteSettingsTrailer',
                },
                // {
                //     label: 'Sharing',
                //     id: 'sharing',
                //     component: 'RouteSettingsSharing',
                // },
            ],
        }
    },
    computed: {
        ...mapGetters(['activeRouteSettings', 'savedRouteSettingsActive', 'activeTransportModeTab', 'savedRouteTime', 'gasConsumptionSettings']),
        initialTab() {
            if(this.activeTransportModeTab && this.activeTransportModeTab !== 'LIST') {
                const activeTab = this.activeTransportModeTab.toLowerCase()
                const tabExists = this.tabs.find(tab => tab.id === activeTab)
                if(tabExists) return activeTab
                return 'general'
            } else {
                return 'car';
            }
        }
    },
    watch: {
        activeRouteSettings() {
            this.setInitialData()
            setTimeout(() => {
                eventBus.$emit('settingsUpdated')
            }, 10);
        },
        gasConsumptionSettings: {
            handler(newVal) {
                for(const key in newVal) {
                    this.data[key] = {...this.data[key], ...newVal[key]}
                }
            },
            deep: true
        }
    },
    mounted() {
        this.setInitialData();
    },
    methods: {
        triggerSave() {
            this.optionsPanelSaveHandler()
        },
        settingsChangeHandler({data, id}) {
            this.data[id] = data;
        },
        optionsPanelSaveHandler() {
            this.saving = true;
            this.$emit('saving', this.saving);
            const dataToSave = JSON.parse(JSON.stringify(this.data))
            const gasConsumptionDataToSave = {}
            // split route and gas consumption settings
            for(const key in dataToSave) {
                if(dataToSave[key].gasConsumption) {
                    gasConsumptionDataToSave[key] = {
                        gasConsumption: dataToSave[key].gasConsumption,
                        gasPrice: dataToSave[key].gasPrice
                    }

                    delete dataToSave[key].gasConsumption,
                    delete dataToSave[key].gasPrice
                }
            }
            this.$store.dispatch('setRouteSettings', dataToSave);
            setPermanentData('route-settings', dataToSave);

            if(this.savedRouteSettingsActive) {
                this.$store.commit('setSavedRouteSettings', false);
            }

            this.$store.commit('setQueryRouteSettings', false);

            updateQueryParams(this.$route, { routeOptions: dataToSave })

            // save gas consumption settings as well
            this.$store.commit('setGasConsumptionSettings', gasConsumptionDataToSave)
            setPermanentData('gas-consumption-settings', gasConsumptionDataToSave)

            setTimeout(() => {
                this.saving = false;
                this.$emit('saving', this.saving);
                eventBus.$emit('reloadRouteResults');
            }, 300);
        },
        setInitialData() {
            // deep clone the values from the store to be used as a starting point for changes
            this.initialData = JSON.parse(JSON.stringify(this.activeRouteSettings));
            // also get gas consumption settings and merge them
            this.initialGasConsumptionData = JSON.parse(JSON.stringify(this.gasConsumptionSettings))
            for(const key in this.initialData) {
                if(this.initialGasConsumptionData[key]) this.initialData[key] = {...this.initialData[key], ...this.initialGasConsumptionData[key]}
            }
            this.data = this.initialData;
        },
        updateView() {
            this.$refs['optionspanel'].initPanelView()
        }
    }
}
</script>

<style lang="scss">
</style>
